import React from 'react';
import {
  Grid,
  Typography,
  Divider,
  TextField,
  MenuItem,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  CardActionArea,
} from '@mui/material';

const SaleInvoiceConsigneeDetails = ({
  consigneeDetails = {},
  states = [],
  isSameDetails = false,
  registrationData = {},
  onChange = () => {},
  openDialog = false,
  setOpenDialog = () => {},
  consigneeList = [],
  setConsigneeList = () => {},
  setLoadingConsignees = () => {},
  loadingConsignees = false,
  BASE_URL = '',
}) => {
  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const handleConsigneeChange = (field, value) => {
    if (field === 'gstin') {
      value = value.toUpperCase();

      if (value.length !== 15) {
        alert("GSTIN must be exactly 15 characters.");
        return;
      }

      if (!gstinRegex.test(value)) {
        alert("Invalid GSTIN format. Example: 27ABCDE1234F1Z5");
        return;
      }
    }

    onChange({ [field]: value });
  };

  const loadFromMasterData = async () => {
    setOpenDialog(true);
    setLoadingConsignees(true);
    try {
      const response = await fetch(`${BASE_URL}/ConsigneeMaster/GetAll`);
      const result = await response.json();
      setConsigneeList(result.data || []);
    } catch (error) {
      console.error('Error fetching consignee data:', error);
    } finally {
      setLoadingConsignees(false);
    }
  };

  const applyConsigneeData = (selected) => {
    onChange({
      name: selected.name || '',
      address: selected.address || '',
      gstin: selected.gstin || '',
      state: selected.state || '',
      stateCode: selected.stateCode?.toString() || '',
    });
    setOpenDialog(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            Consignee Details
          </Typography>
          <Divider sx={{ mb: 2 }} />
        </Grid>

        {isSameDetails ? (
          <>
            <Grid item xs={12}><Typography>Name: {registrationData?.firstName || 'N/A'}</Typography></Grid>
            <Grid item xs={12}><Typography>Address: {registrationData?.address || 'N/A'}</Typography></Grid>
            <Grid item xs={12}><Typography>GSTIN: {registrationData?.gst || 'N/A'}</Typography></Grid>
            <Grid item xs={12}><Typography>State: {registrationData?.stateName || 'N/A'}</Typography></Grid>
            <Grid item xs={12}><Typography>State Code: {registrationData?.stateCode || 'N/A'}</Typography></Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} md={6}>
              <TextField
                label="Name"
                value={consigneeDetails.name}
                onChange={(e) => handleConsigneeChange('name', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Address"
                value={consigneeDetails.address}
                onChange={(e) => handleConsigneeChange('address', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="GSTIN"
                value={consigneeDetails.gstin}
                onChange={(e) => handleConsigneeChange('gstin', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                label="State"
                value={consigneeDetails.stateCode}
                onChange={(e) => {
                  const selectedCode = e.target.value;
                  const matchedState = states.find((s) => s.stateCode === selectedCode);
                  handleConsigneeChange('stateCode', selectedCode);
                  handleConsigneeChange('state', matchedState?.stateName || '');
                }}
                fullWidth
              >
                <MenuItem value=""><em>Select State</em></MenuItem>
                {states.map((state) => (
                  <MenuItem key={state.id} value={state.stateCode}>
                    {state.stateName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Button variant="outlined" onClick={loadFromMasterData}>Load from Master Data</Button>
        </Grid>
      </Grid>

      {/* Dialog for selecting from master data */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Select Consignee</DialogTitle>
        <DialogContent dividers>
          {loadingConsignees ? (
            <CircularProgress />
          ) : consigneeList.length > 0 ? (
            <Grid container spacing={2}>
              {consigneeList.map((consignee, idx) => (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Card variant="outlined">
                    <CardActionArea onClick={() => applyConsigneeData(consignee)}>
                      <CardContent>
                        <Typography><b>Name:</b> {consignee.name}</Typography>
                        <Typography><b>Address:</b> {consignee.address}</Typography>
                        <Typography><b>GSTIN:</b> {consignee.gstin}</Typography>
                        <Typography><b>State:</b> {consignee.state}</Typography>
                        <Typography><b>Code:</b> {consignee.stateCode}</Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>No consignee records found.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="secondary">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SaleInvoiceConsigneeDetails;
